export default __webpack_public_path__ + "static/media/t500.c56e581b.mp4";